import { render, staticRenderFns } from "./CompareHistory.vue?vue&type=template&id=f3016db2&scoped=true&"
import script from "./CompareHistory.vue?vue&type=script&lang=js&"
export * from "./CompareHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3016db2",
  null
  
)

export default component.exports